<template>
    <div class="sidebar">
        <div class="sidebar-navigation">
            <slot/>
        </div>
        <div class="sidebar-navigation-bottom">
            <slot name="bottom"/>
        </div>
    </div>
</template>

<script>
    import SidebarNotificationBox from "./SidebarNotificationBox";
    export default {
        name: "Sidebar",
        components: {SidebarNotificationBox},
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

    .sidebar {
        display: flex;
        flex-flow: column;
        height: 100%;
        border-radius: 6px;
        font-family: Poppins;
        font-size: 12px;
        text-transform: uppercase;
    }

    .user-box {
        display: inline-block;
        white-space: pre;
        padding: 0 0;
    }

    .sidebar-notifications {
        display: grid;
        grid-template: 3/1;
        background-color: var(--accent-color);
    }

    .sidebar-navigation {
        height: 100%;
        background:linear-gradient(to left, var(--accent-color) 5%, #C85858 100%);
    }

    .sidebar-navigation-bottom {
      background:linear-gradient(to left, var(--accent-color) 5%, #C85858 100%);
    }

</style>